<template>
    <div v-loading="loading">
        <zm-form label-position="left" class="demo-table-expand" label-width="110px">
            <zm-form-item label="channelId">
                {{ channelId }}
            </zm-form-item>
            <zm-form-item label="status">
                <img class="point" v-if="clusterStatus === 'RED'" src="../../assets/red-point.png">
                <img class="point" v-if="clusterStatus === 'GREEN'" src="../../assets/green-point.png">
                <img class="point" v-if="clusterStatus === 'YELLOW'" src="../../assets/yellow-point.png">
            </zm-form-item>
            <zm-form-item label="sslEnable">
                {{ sslEnable }}
                <zm-button size="small" type="icon" icon="zm-icon-delete" @click="deleteSsl" v-if="sslEnable && hasPermission"></zm-button>
            </zm-form-item>
            <zm-form-item label="sslEndPoint" v-if="sslEnable">
                {{ sslEndPoint }}
            </zm-form-item>
            <!-- <zm-form-item label="broadcast">
                {{ broadcast }}
            </zm-form-item> -->
            <zm-form-item label="reportTaskTopicUrl" label-width="180px">
                {{ reportTaskTopicUrl }}
            </zm-form-item>
            <zm-form-item label="reportMetricsTopicUrl" label-width="180px">
                {{ reportMetricsTopicUrl }}
            </zm-form-item>
            <zm-form-item label="sslActive" v-if="sslEnable">
                <img class="point" v-if="sslActive" src="../../assets/green-point.png">
                <img class="point" v-else src="../../assets/red-point.png">
            </zm-form-item>
            <zm-form-item label="autoCreateTopicDisable" label-width="170px">
                {{ autoCreateTopicDisable }}
            </zm-form-item>
            <zm-form-item label="operateTopicDisable" label-width="170px">
                {{ operateTopicDisable }}
            </zm-form-item>
            <zm-form-item label="assignBackupChannelName" label-width="200px">
                {{ assignBackupChannelName }}
            </zm-form-item>
            <zm-form-item label="currentBackupChannelName" label-width="200px">
                {{ currentBackupChannelName }}
            </zm-form-item>
        </zm-form>
        <zm-table :data="nodeInfos" border>
            <zm-table-column prop="id" label="id" align="center"></zm-table-column>
            <zm-table-column prop="host" label="host" align="center"></zm-table-column>
            <zm-table-column prop="nodeStatus" label="nodeStatus" align="center"></zm-table-column>
        </zm-table>
        </div>
</template>
<script>
import {
    getChannelById,
    deleteSsl
} from '../../api/index'
export default {
    name: 'channelDetail',
    props: ['id'],
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: true,
            nodeInfos: [],
            clusterStatus: '',
            channelId: '',
            autoCreateTopicDisable: null,
            operateTopicDisable: null,
            sslEnable: false,
            sslActive: false,
            broadcast: null,
            reportTaskTopicUrl: '',
            reportMetricsTopicUrl: '',
            assignBackupChannelName: '',
            currentBackupChannelName: '',
            sslEndPoint: ''
        }
    },
    created () {
       this.fetchData()
    },
    methods: {
        fetchData () {
            this.loading = true
            getChannelById(this.id).then(response => {
                this.channelId = response.channelId
                this.nodeInfos = response.nodeInfos
                this.clusterStatus = response.clusterStatus
                this.sslEnable = response.sslEnable
                this.sslEndPoint = response.sslEndPoint
                this.sslActive = response.sslActive
                this.broadcast = response.broadcast
                this.reportTaskTopicUrl = response.reportTaskTopicUrl
                this.reportMetricsTopicUrl = response.reportMetricsTopicUrl
                this.autoCreateTopicDisable = response.autoCreateTopicDisable
                this.operateTopicDisable = response.operateTopicDisable
                this.assignBackupChannelName = response.assignBackupChannelName
                this.currentBackupChannelName = response.currentBackupChannelName
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        deleteSsl () {
            this.loading = true
            this.$confirm('This will permanently delete the SSL. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                deleteSsl(this.id).then(response => {
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                    this.loading = false
                    this.fetchData()
                }).catch(() => {
                    this.$message({
                        message: 'Delete error!',
                        type: 'error'
                    })
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        }
    }
}
</script>
